import { html } from 'lit';

export const renderSimpleStat = ({
  theme,
  stat,
  text,
  subText,
  size,
  hasLine,
  displayType,
}: SimpleStatProps) => html`
  <umd-element-stat
    data-theme="${theme}"
    data-visual-size="${size}"
    ?data-decoration-line="${hasLine}"
    data-display="${displayType}"
  >
    <div slot="stat">${stat}</div>
    <div slot="text">${text}</div>
    <div slot="sub-text">${subText}</div>
  </umd-element-stat>
`;

export type SimpleStatProps = {
  theme?: 'light' | 'dark';
  stat?: string;
  text?: string;
  subText?: string;
  size?: '' | 'large';
  hasLine?: boolean;
  displayType?: 'block' | '';
};

export const SimpleStat = (props: SimpleStatProps) => renderSimpleStat(props);
